import { connect } from 'react-redux';
import isCompanyAdmin from 'store/selectors/isCompanyAdmin';

const mapStateToProps = state => ({
  isCompanyAdmin: isCompanyAdmin(state),
});

const mapDispatchToProps = () => ({
  actions: {},
});

export default connect(mapStateToProps, mapDispatchToProps);
